/**
 * Created by carlos on 06/11/2024.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('ssrRManifest', {
                parent: 'app',
                url: '/ssrRManifest',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/manifest/ssrRManifest/ssrRManifest.html',
                        controller: 'luggageManifestCtrlSsr',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabManifestos('ssrRManifest')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generalManifest']);
                            }],
                            airports:['airportService',function(airportService){
                                return airportService.getAirportsActiveDisable(true);
                            }]
                        }
                    }
                }
            });
    }
})();
